module.exports = __webpack_public_path__ + "static/img/win10_3.45db51e.png";